// extracted by mini-css-extract-plugin
export default {"vimeoVideo":"CmsVimeo-module__vimeoVideo-NBN4X0"};